export const formatSar = (minorUnits, lang = "ar") => {
  const value = Number(minorUnits || 0) / 100;
  return new Intl.NumberFormat(lang === "ar" ? "ar-SA" : "en-US", {
    style: "currency",
    currency: "SAR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

// Same currency format with Western digits, for dense finance tables whose dates and references use them too.
export const formatSarLatin = (minorUnits, lang = "ar") => {
  const value = Number(minorUnits || 0) / 100;
  return new Intl.NumberFormat(lang === "ar" ? "ar-SA-u-nu-latn" : "en-US", {
    style: "currency",
    currency: "SAR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const hasValidSarPrecision = (value) => /^\d+(\.\d{1,2})?$/.test(String(value || "").trim());

// Mirrors the backend's utils/billingMoney.sarToMinorUnits parsing rules for
// client-side form handling. The server independently re-validates and
// re-derives every amount — this is only for building request payloads.
export const sarToMinorUnits = (value) => {
  const raw = String(value ?? "").trim();
  if (!hasValidSarPrecision(raw)) {
    throw new Error("Amount must be a SAR value with at most two decimals");
  }
  const [whole, fraction = ""] = raw.split(".");
  return Number(whole) * 100 + Number(fraction.padEnd(2, "0"));
};

